export default "skymp5-front/2f232428adfdc39e187cbb076d77e70f.gif";